export var VALIDATION_CHECK;
(function (VALIDATION_CHECK) {
    VALIDATION_CHECK["REQUIRED"] = "required";
    VALIDATION_CHECK["WHITESPACE"] = "whitespace";
    VALIDATION_CHECK["MIN"] = "min";
    VALIDATION_CHECK["MAX"] = "max";
    VALIDATION_CHECK["TYPE"] = "type";
    VALIDATION_CHECK["PATTERN"] = "pattern";
})(VALIDATION_CHECK || (VALIDATION_CHECK = {}));
//# sourceMappingURL=validation.js.map